import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { MapToggleComponent } from './map-toggle.component';

@NgModule({
  declarations: [MapToggleComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule.forChild(),
    FlexLayoutModule,
  ],
  exports: [MapToggleComponent],
})
export class MapToggleModule {}
